import {WhitespaceValidator} from '@spa/validators';

import {AmountControl, BaseControl, SelectControl} from 'appShared/classes/controls';
import {ComponentTypesEnum} from 'appShared/enums/common';
import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {CurrencyTypesEnum} from '@spa/api';
import {Validators} from '@angular/forms';
import {Helper} from 'appShared/classes';

export const AddNewPlatformFrontendNameSelector = 'addNewPlatformFrontendName';
export const AddNewPlatformFrontendDescriptionSelector = 'addNewPlatformFrontendDescription';
export const AddNewPlatformFrontendPlatformIdSelector = 'addNewPlatformFrontendPlatformId';
export const AddNewPlatformFrontendPriceSelector = 'addNewPlatformFrontendPrice';
export const AddNewPlatformFrontendCurrencySelector = 'addNewPlatformFrontendCurrency';

export const AddNewPlatformFrontendDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const AddNewPlatformFrontendControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: AddNewPlatformFrontendNameSelector,
            value: '',
            placeholder: 'Name',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewPlatformFrontendDescriptionSelector,
            value: '',
            placeholder: 'Description',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
        }),
        new SelectControl({
            name: AddNewPlatformFrontendPlatformIdSelector,
            value: null,
            placeholder: 'Trading Platform',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new AmountControl({
            name: AddNewPlatformFrontendPriceSelector,
            value: null,
            placeholder: 'Price',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            isInitialFormattingActive: true,
            currency: null
        }),
        new SelectControl({
            name: AddNewPlatformFrontendCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
    ];
};
